import React, {useEffect, useRef} from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {fontFamily} from '../../../helpers/fontFamily';
import {
  accentColor,
  hairlineColor,
  textColor,
  textMutedColor
} from '../../../style/adminTools';
import {colors} from '../../../style/rulesEngine';

const ColumnsMenu = ({columns, hidden, onToggle, onClose}) => {
  const menuRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  const visibleCount = columns.filter(column => !hidden[column.name]).length;

  useEffect(() => {
    const onKeyDown = event => {
      if (event.key === 'Escape') closeRef.current();
    };
    const onPointerDown = event => {
      const anchor = menuRef.current && menuRef.current.parentNode;
      if (anchor && !anchor.contains(event.target)) closeRef.current();
    };
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('touchstart', onPointerDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('touchstart', onPointerDown);
    };
  }, []);

  return (
    <View
      ref={menuRef}
      testID="tenantColumnsMenu"
      style={{
        position: 'absolute',
        top: '100%',
        right: 0,
        marginTop: 6,
        width: 270,
        maxHeight: 360,
        paddingVertical: 6,
        backgroundColor: colors.cardBg,
        borderWidth: 1,
        borderColor: colors.borderStrong,
        borderRadius: 8,
        zIndex: 1000,
        overflow: 'scroll'
      }}
    >
      {columns.map(column => {
        const checked = !hidden[column.name];
        const isLastVisible = checked && visibleCount === 1;
        return (
          <TouchableOpacity
            key={column.name}
            testID={`columnToggle-${column.name}`}
            accessibilityRole="checkbox"
            accessibilityState={{checked, disabled: isLastVisible}}
            disabled={isLastVisible}
            onPress={() => {
              if (!isLastVisible) onToggle(column.name);
            }}
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              paddingHorizontal: 14,
              paddingVertical: 8,
              opacity: isLastVisible ? 0.5 : 1
            }}
          >
            <View
              style={{
                width: 18,
                height: 18,
                marginRight: 10,
                borderRadius: 4,
                borderWidth: 2,
                borderColor: checked ? accentColor : hairlineColor,
                backgroundColor: checked ? accentColor : 'transparent'
              }}
            />
            <Text
              style={{
                fontFamily: fontFamily.font500,
                fontSize: 13,
                color: checked ? textColor : textMutedColor
              }}
            >
              {column.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

export default ColumnsMenu;
